module.exports = __webpack_public_path__ + "assets/img/37_1477_big.0dab5ab0.jpg";